// 处理toast打包后报错的文件

class ToastEvent {
  static error = (msg: string) => {
    console.warn('Toast event triggered before initialization:', msg);
  };
  
  static success = (msg: string) => {
    console.log('Success:', msg);
  };
  static info = (msg: string) => {
    console.log('Info:', msg);
  };
  static register(methods: { error: (msg: string) => void; success: (msg: string) => void; info: (msg: string) => void }) {
    this.error = methods.error;
    this.success = methods.success;
    this.info = methods.info;
  }
}

export default ToastEvent;